import { render, staticRenderFns } from "./SpecimenSurveyQueryTab.vue?vue&type=template&id=88c52ef0"
import script from "./SpecimenSurveyQueryTab.vue?vue&type=script&lang=js"
export * from "./SpecimenSurveyQueryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports